var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('region-map',{staticClass:"maplogo",attrs:{"hour":parseInt(_vm.hour),"type":_vm.type,"rundate":_vm.mapRundate,"weatherregion":_vm.region}}),_c('weather-legend',{attrs:{"type":"legend-precip"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }